import { Component, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { AgentProvider } from '../../providers/agent/agent';
import { UtilsProvider } from '../../providers/myria/utils-provider';
import { IAgentCity } from '../../model/models/agent/agent-city.interface';
import { LoggerProvider, LoggerEvent } from '../../providers/logger/logger';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'rmt-search-city',
  templateUrl: 'rmt-search-city.html'
})
export class RmtSearchCityComponent {
  @Input() country;
  @Input() deliveryMethod;
  @Input() showSearchAlert;
  @Input() onSelectCityCb;
  @Output() onSelect = new EventEmitter<IAgentCity>();
  @Output() ionChange = new EventEmitter<string>();
  @ViewChild('address') addressdiv;
  searching: boolean = false;
  inputTimeout;
  lastSearch;
  cities;
  selectedCity;
  ignoreChange;
  colorOutline;
  placeholder: string = this.translate.instant('page.chooseLocationPage.searchBar');
  searchAlertIcon = "assets/icons/telescope-bank.svg"
  noResultsIcon = "assets/icons/magnifying-glass.svg";
  address;

  constructor(private agentProvider: AgentProvider,
              private translate: TranslateService,
              private utilsProvider: UtilsProvider) {
  }

  ngAfterViewInit() {
    this.address = this.addressdiv ? this.addressdiv.searchdiv : {};
  }

  setValue(value, noChange = false) {
    if (this.inputTimeout)
      window.clearTimeout(this.inputTimeout);
    if (noChange)
      this.ignoreChange = value;
    this.address.value = value;
  }

  getValue() {
    return this.address.value;
  }

  changeAddress() {
    if (this.inputTimeout)
      window.clearTimeout(this.inputTimeout);
    if (this.ignoreChange && this.ignoreChange === this.address.value) {
      this.ignoreChange = null;
      return;
    }

    this.cities = null;
    this.lastSearch = null;
    if(!this.address.value){
      this.selectCity(null);
      this.searching = false;
    }
    this.ionChange.emit(this.address.value);

    this.inputTimeout = window.setTimeout(() => {
      this.inputTimeout = null;
       if(this.address.value)
        this.searchAddress();
    }, 250);
  }

  async searchAddress() {
    this.selectCity(null)
    this.searching = true
    let cities = null;
    let city = this.address.value
    let state = null;
    const address = this.address.value;
    this.lastSearch = address;
    try {
      if (city) {
        const parts = city.split(',')
        if (parts.length === 2) {
          city = parts[0].trim();
          state = parts[1].trim();
        }
      }
      const payload = {
        countryTo: this.country,
        deliveryMethod: this.deliveryMethod,
        city: city
      };
      cities = await this.agentProvider.getAgentCities(payload);
    }
    catch (ex) {
      cities = null;
      LoggerProvider.exception(this, ex, LoggerEvent.ComponentException, 'Failed to get agent cities in search city component');
    }

    if (this.lastSearch === address) {
      if (cities && state)
        cities = cities.filter((city) => (city.state.indexOf(state) >= 0 || city.stateAbbreviation === state));
      if (cities && cities.length > 0)
        this.cities = cities;
      else{
        this.cities = null;
        this.searching = false
      }
      if (this.cities) {
        const match = this.agentProvider.findMatchingCity(this.cities, city, state);
        if (match)
          this.searchSelectedCity(match);
        else
          this.searching = false;
      }
    }

  }

  async searchSelectedCity(city: IAgentCity) {
    let locations = this.onSelectCityCb ? await this.onSelectCityCb(city) : [];
    if(locations && locations.length > 0) {
    this.selectCity(city);
    } else {
      this.address.value = "";
      this.ionChange.emit(this.address.value)
      this.selectCity(null)

    }

  }

  // emitSelect = false for callers that already searched this city
  selectCity(city: IAgentCity, emitSelect = true) {
    if (emitSelect)
      this.onSelect.emit(city);
    this.selectedCity = city;
    if (city)
      this.setValue(city.cityName + ', ' + city.state, true);
      this.searching = false;

  }

  getCity() {
    return this.selectedCity;
  }

  getFontSize(element) {
    if (element && element.value) {
      if (element.value.length >= 45)
        return '12px';
      else if (element.value.length >= 40)
        return '13px';
      else if (element.value.length >= 35)
        return '14px';
      else if (element.value.length >= 30)
        return '15px';
    }
    return '16px';
  }

  setBorderColor(color) {
    this.colorOutline = color;
  }

  focus(){
    this.setBorderColor('orange');
  }

  blur(){
    this.setBorderColor('black');
  }

  clearCityResult(){
    this.cities = null;
    this.lastSearch = null;
    this.searching = false;

  }

  getCityResultText(city: IAgentCity){
    let cityResult = `${city.cityName} ,  ${city.state}`
    cityResult = this.utilsProvider.highlightMatchSearchResult(cityResult, this.address.value)
    return cityResult;
  }


}



// WEBPACK FOOTER //
// ./src/components/rmt-search-city/rmt-search-city.ts